// ── Mit ellenőrzünk minden eladott telefonon? ──────────────────────────────
//
// EGYETLEN FORRÁS. Minden oldal, amely a bevizsgálásról beszél (termékoldal,
// /telefonok, /miert-norbiphone, /felvasarlas, GYIK, főoldal), innen veszi a
// listát és a darabszámot. Korábban hat helyen hat különböző lista élt
// (4, 5, 6, „hét pont”, „32 pontos”) – ez egymásnak ellentmondott.
//
// A lista a tulajdonos jóváhagyott folyamata (2026-09-30). FOLYAMAT-állítás:
// ezt nézzük meg minden darabon. Készülékenkénti eredményt az office API nem
// tárol – ezért sehol ne írjuk, hogy „ennél a darabnál X rendben volt”.
//
// Új pont csak akkor kerülhet ide, ha a pultban TÉNYLEG minden darabon
// megcsináljátok. A darabszám (ELLENORZES_DB) automatikusan követi.

export const ELLENORZESI_PONTOK = Object.freeze([
  { key: 'akku',     cim: 'Akkumulátor',                  leiras: 'Akku-egészség műszerrel lemérve, %-ban — ezt írjuk ki a termékoldalon.' },
  { key: 'kijelzo',  cim: 'Kijelző',                      leiras: 'Törés, folt, elszíneződés, érintés-holt zóna — végignézzük.' },
  { key: 'kamera',   cim: 'Kamerák',                      leiras: 'Elő- és hátsó kamera, élesség, autofókusz, vaku.' },
  { key: 'biometria', cim: 'Face ID / Touch ID',          leiras: 'Az arc- vagy ujjlenyomat-azonosítás működik-e.' },
  { key: 'hang',     cim: 'Mikrofon és hangszóró',        leiras: 'Hívás, hangszóró, mikrofon, csörgés — mind kipróbálva.' },
  { key: 'toltes',   cim: 'Töltés',                       leiras: 'Töltőport és töltés — tölt-e rendesen a készülék.' },
  { key: 'vezetek_nelkuli', cim: 'Wi-Fi / Bluetooth',     leiras: 'Csatlakozik-e Wi-Fi-hálózathoz és Bluetooth-eszközhöz.' },
  { key: 'gombok',   cim: 'Gombok',                       leiras: 'Bekapcsoló, hangerő, némító — minden gomb.' },
  { key: 'szenzorok', cim: 'Szenzorok',                   leiras: 'A készülék érzékelői működnek-e.' },
  { key: 'fiokzar',  cim: 'iCloud fiók / aktiválási zár', leiras: 'Nincs az előző tulajdonos fiókjához kötve — a sajátodra állíthatod be.' },
  { key: 'halozat',  cim: 'Hálózatfüggetlenség',          leiras: 'Megnézzük, bármelyik szolgáltató SIM-kártyájával működik-e.' },
  { key: 'vizkar',   cim: 'Vízkárnyomok',                 leiras: 'Folyadékkal érintkezés nyomait keressük.' },
  { key: 'kulso',    cim: 'Külső állapot',                leiras: 'Karc, kopás, horpadás — ebből adódik az állapot-besorolás.' },
]);

export const ELLENORZES_DB = ELLENORZESI_PONTOK.length;

/** „Akkumulátor · Kijelző · …” – a teljes lista egy sorban. */
export const ELLENORZES_SOR = ELLENORZESI_PONTOK.map((p) => p.cim).join(' · ');

/** Folyó szövegbe: „akkumulátor, kijelző, … és külső állapot”. */
export const ELLENORZES_FOLYO = (() => {
  const nevek = ELLENORZESI_PONTOK.map((p) =>
    // Tulajdonnév (Face ID, iCloud, Wi-Fi) marad nagybetűs, a többi kisbetűs.
    /^(Face|iCloud|Wi-Fi)/.test(p.cim) ? p.cim : p.cim.charAt(0).toLowerCase() + p.cim.slice(1));
  return `${nevek.slice(0, -1).join(', ')} és ${nevek[nevek.length - 1]}`;
})();

/** A /miert-norbiphone bevizsgálási szekciójának horgonya. */
export const ELLENORZES_HORGONY = 'bevizsgalas';
